/* -------------------------------------------------------------------------- */
/*                                   Tooltip                                  */
/* -------------------------------------------------------------------------- */
const tooltipInit = root => {
  if (window.TooltipsFalconGlobal && typeof window.TooltipsFalconGlobal.init === 'function') {
    window.TooltipsFalconGlobal.init(root || document);
  }
};

export default tooltipInit;
